import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ContentRoute } from '../../../../_metronic/layout';
import { Permissions } from '../../../util/Permissions';
import { SubHeader } from '../../Common/layout/SubHeader';
import { BillingHistory } from './components/BillingHistory';
import { FeeSettings } from './components/FeeSettings';
import { MaintenanceFeeSettings } from './components/MaintenanceFeeSettings';
import { SearchAccount } from './components/SearchAccount';

export const MaintenanceFeeManagement = ({
  match: {
    params: { userGroup },
  },
}) => {
  return (
    <>
      <SubHeader>
        <SubHeader.Nav>
          <SubHeader.NavItem label="Billing History" to={`/maintenance/${userGroup}/accounts/billing-history`} />
          <SubHeader.NavItem label="Fee Settings" to={`/maintenance/${userGroup}/accounts/maintainance-fee-settings`} />
          <SubHeader.NavItem label="Exempt Account" to={`/maintenance/${userGroup}/accounts/search-account`} />
        </SubHeader.Nav>
      </SubHeader>
      <div className="py-4 px-6">
        <Switch>
          <Redirect exact from={`/maintenance/${userGroup}`} to={`/maintenance/${userGroup}/accounts/billing-history`} />
          <ContentRoute path={`/maintenance/${userGroup}/accounts/billing-history`} permission={Permissions.MAINTENANCE_FEE} component={BillingHistory} />
          <ContentRoute path={`/maintenance/${userGroup}/accounts/maintainance-fee-settings`} permission={Permissions.MAINTENANCE_FEE} component={MaintenanceFeeSettings} />
          <ContentRoute path={`/maintenance/${userGroup}/accounts/search-account`} permission={Permissions.MAINTENANCE_FEE} component={SearchAccount} />
        </Switch>
      </div>
    </>
  );
};
